import { useMemo } from 'react';

import type { SpokenPickExtractionPort } from '@/shared-responder-v2-core';

import {
  createSpokenPickExtractionPort,
  type SpokenPickQueryResult,
} from './shared-responder-v2-spoken-pick-port';
import {
  toSpokenPickQueryInput,
  type SpokenPickQueryInput,
} from './shared-responder-v2-spoken-pick.helpers';

export function useSpokenPickPortFromQuery(
  executeQuery: (options: {
    readonly variables: { readonly input: SpokenPickQueryInput };
  }) => Promise<SpokenPickQueryResult>
): SpokenPickExtractionPort {
  return useMemo(
    () =>
      createSpokenPickExtractionPort((input) =>
        executeQuery({ variables: { input: toSpokenPickQueryInput(input) } })
      ),
    [executeQuery]
  );
}
